(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const desktopMQ = window.matchMedia('(min-width: 990px)');

    function bindMegaMenuHover() {
      const detailsList = document.querySelectorAll(
        '.header__inline-menu header-menu details.mega-menu'
      );

      detailsList.forEach((details) => {
        // Nur einmal pro Element binden
        if (details.dataset.hoverBound === 'true') return;
        details.dataset.hoverBound = 'true';

        let hideTimeout;

        details.addEventListener('mouseenter', () => {
          if (!desktopMQ.matches) return; // nur Desktop
          clearTimeout(hideTimeout);
          details.setAttribute('open', ''); // Mega-Menü öffnen
        });

        details.addEventListener('mouseleave', () => {
          if (!desktopMQ.matches) return; // nur Desktop
          hideTimeout = setTimeout(() => {
            details.removeAttribute('open'); // Mega-Menü schließen
          }, 120); // kleiner Delay für „weichere“ Bewegung
        });
      });
    }

    // Initial beim Laden
    bindMegaMenuHover();

    // Im Theme-Editor, wenn Header neu geladen wird
    document.addEventListener('shopify:section:load', bindMegaMenuHover);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const desktopMQ = window.matchMedia('(min-width: 990px)');

    function bindMegaMenuHover() {
      const detailsList = document.querySelectorAll(
        '.header__inline-menu header-menu details.mega-menu'
      );

      detailsList.forEach((details) => {
        // Nur einmal pro Element binden
        if (details.dataset.hoverBound === 'true') return;
        details.dataset.hoverBound = 'true';

        let hideTimeout;

        details.addEventListener('mouseenter', () => {
          if (!desktopMQ.matches) return; // nur Desktop
          clearTimeout(hideTimeout);
          // Alle anderen offenen Mega-Menüs sofort schließen (verhindert Overlap
          // beim schnellen Wechsel zwischen L1-Items während des 200ms Close-Delays)
          document.querySelectorAll(
            '.header__inline-menu header-menu details.mega-menu[open]'
          ).forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
          details.setAttribute('open', ''); // Mega-Menü öffnen
        });

        details.addEventListener('mouseleave', () => {
          if (!desktopMQ.matches) return; // nur Desktop
          hideTimeout = setTimeout(() => {
            details.removeAttribute('open'); // Mega-Menü schließen
          }, 200); // Delay für weichere Bewegung (Hover-Bridge Sicherheitsnetz)
        });
      });
    }

    // Initial beim Laden
    bindMegaMenuHover();

    // Im Theme-Editor, wenn Header neu geladen wird
    document.addEventListener('shopify:section:load', bindMegaMenuHover);
  });

  } catch(e) { console.error(e); }
})();
})();
